module.exports = __webpack_public_path__ + "static/img/05-中国农业大学附属中学1.4d56401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/05-中国农业大学附属中学1.png
// module id = 90UK
// module chunks = 0